import { axios } from "@/lib/axios";
import { QueryConfig } from "@/lib/react-query";
import { AxiosError } from "axios";
import { useSnackbar } from "notistack";
import { useQuery } from "react-query";

export interface LeadValidation {
  partnerName: string;
}

const getValidationLead = async ({
  guid,
}: {
  guid: number | string | undefined;
}): Promise<LeadValidation> => {
  if (!guid) {
    return Promise.reject("GUID is required");
  }

  const response = await axios.get<LeadValidation>(
    `/leads/validateLead/${guid}`
  );
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  //@ts-ignore
  return response;
};

type QueryFnType = typeof getValidationLead;
type ExtractedFnReturnType = LeadValidation;

type UseLeadOptions<SelectedData> = {
  guid: number | string | undefined;
  config?: QueryConfig<QueryFnType, SelectedData>;
};

export const useValidationLead = <SelectedData = ExtractedFnReturnType>({
  config,
  guid,
}: UseLeadOptions<SelectedData>) => {
  const { enqueueSnackbar } = useSnackbar();
  return useQuery<ExtractedFnReturnType, AxiosError, SelectedData>({
    ...config,
    queryKey: ["leads", guid],
    queryFn: () => getValidationLead({ guid }),
    enabled: !!guid,
    refetchOnWindowFocus: false,
    refetchOnMount: true,
    staleTime: 0,
    cacheTime: 0,
    onError: (error) => {
      const message = error.response?.data?.message || error.message;
      enqueueSnackbar(message, { variant: "error" });
    },
  });
};
